import { useState } from "react";
import { Sparkles, Plus, ArrowRight } from "lucide-react";
import { NewExpenseDialog } from "../components/NewExpenseDialog";

// The Assistant tab previously hosted a fake Google Chat demo with hardcoded
// Sarah Connor messages, a mock receipt image, and a Confirm/Reset flow that
// didn't touch real data. That surface depended on an AI backend that doesn't
// exist yet, so we've replaced it with a "Coming soon" panel pointing at the
// real manual-entry path (New Expense in the top bar).
export function Assistant() {
  const [newExpenseOpen, setNewExpenseOpen] = useState(false);

  return (
    <div className="h-full flex flex-col max-w-3xl mx-auto">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Assistant</h1>
          <p className="text-slate-500 mt-1">
            AI-powered expense capture via chat
          </p>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center py-10">
        <div
          data-testid="assistant-coming-soon"
          className="bg-white rounded-2xl shadow-sm border border-slate-200 p-10 max-w-xl w-full text-center flex flex-col items-center gap-4"
        >
          <div className="w-14 h-14 rounded-2xl bg-[#E8F0FE] flex items-center justify-center">
            <Sparkles className="w-7 h-7 text-[#1A73E8]" />
          </div>

          <h2 className="text-xl font-bold text-slate-900">Coming soon</h2>

          <p className="text-sm text-slate-600 leading-relaxed">
            The Assistant will let your team drop receipts into Slack or Google
            Chat and have Proofly pre-fill the category, tax policy, and
            business purpose from the receipt. That workflow depends on AI
            integrations we haven&apos;t shipped yet.
          </p>

          <div className="w-full bg-slate-50 border border-slate-100 rounded-xl px-4 py-3 text-left">
            <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-1">
              In the meantime
            </p>
            <p className="text-sm text-slate-700">
              Add an expense manually using the{" "}
              <span className="font-semibold">New Expense</span> button in the
              top bar. Every downstream tab (Inbox, Expenses, Audit, Exports)
              reads from the same data, so nothing is lost by starting there.
            </p>
          </div>

          <button
            type="button"
            data-testid="assistant-new-expense-cta"
            onClick={() => setNewExpenseOpen(true)}
            className="mt-2 inline-flex items-center gap-2 px-4 py-2 bg-[#0070F2] hover:bg-[#005BCA] text-white text-sm font-medium rounded-md shadow-sm transition-colors"
          >
            <Plus className="w-4 h-4" /> New Expense{" "}
            <ArrowRight className="w-4 h-4 opacity-80" />
          </button>
        </div>
      </div>

      <NewExpenseDialog
        open={newExpenseOpen}
        onOpenChange={setNewExpenseOpen}
        mode="create"
      />
    </div>
  );
}
